// extracted by mini-css-extract-plugin
export default {"container":"empty-list_container__h8Q4b"};